// extracted by mini-css-extract-plugin
module.exports = {"title":"Statistics_title__3eukK","area":"Statistics_area__34DqS","titleGlobal":"Statistics_titleGlobal__9_Ku4"};